import React, { useState } from "react";
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import solisPowerApi from "../../api/solisPowerApi";
import PubSub from "pubsub-js";
import Helmet from "react-helmet";
import Main from "../layout/Main";
import { handleUppercaseChange } from "../common/UpperCaseMethod";
import { ROUTES } from "../../constants/webRouting";


const CategoryEdit = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [category, setCategory] = useState(location.state ? location.state : { status: "Active" });

  const handleChange = (e) => setCategory({ ...category, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!category.category_name || category.category_name.trim() === "") {
      setValidated(true);
      return;
    }
    try {
      if (category.id) {
        const result = await solisPowerApi.updateCategory(category);
        if (result && result.success) {
          PubSub.publish("RECORD_SAVED_TOAST", { title: "Record Saved", message: "Updated successfully" });
          navigate(ROUTES.CATEGORY.LIST);
        }
      } else {
        const result = await solisPowerApi.createCategory(category);
        if (result && result.product_exists) {
          PubSub.publish("RECORD_SAVED_TOAST", { title: "Error", message: result.message });
          return;
        }
        if (result && result.success) {
          PubSub.publish("RECORD_SAVED_TOAST", { title: "Record Saved", message: "Created successfully" });
          navigate(ROUTES.CATEGORY.LIST);
        }
      }
    } catch (err) {
      PubSub.publish("RECORD_SAVED_TOAST", { title: "Error", message: "Something went wrong" });
    }
  };

  return (
    <Main>
      <Helmet>
        <title>Category Edit</title>
      </Helmet>
      <Container className="view-form">
        <Row>
          <Col lg={8} className="mx-auto pb-1 pt-2">
            <Link className="nav-link" to={ROUTES.CATEGORY.LIST}>
              Home <i className="fa-solid fa-chevron-right"></i> <div style={{ color: "#23468c", display: "inline" }}>Categories</div>
            </Link>
          </Col>
        </Row>
        <Row>
          <Col lg={8} className="mx-auto">
            <Form className="mt-3" onSubmit={handleSubmit} noValidate validated={validated}>
              <Row className="view-form-header">
                <Col lg={8}>{category.id ? <h5>Edit Category</h5> : <h5>Create Category</h5>}</Col>
                <Col lg={4} className="d-flex justify-content-end gap-3">
                  <Button size="sm" className="btn-save" onClick={handleSubmit}>Save</Button>
                  <Button size="sm" className="btn-cancel" onClick={() => navigate(ROUTES.CATEGORY.LIST)}>Cancel</Button>
                </Col>
              </Row>
              <Row className="ibs-edit-form pb-3">
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">Category Name</Form.Label>
                    <Form.Control required type="text" name="category_name" placeholder="Enter Category Name" value={category.category_name || ""} onChange={(e) => handleUppercaseChange(e, handleChange)} />
                    <Form.Control.Feedback type="invalid">Please provide Category Name.</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">Status</Form.Label>
                    <Form.Select name="status" value={category.status || "Active"} onChange={handleChange} required>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">Please provide Status.</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </Main>
  );
};

export default CategoryEdit;
